export const MAX_TRANSACTION_NUMBERS = 3;

export const parseTransactionNumbers = (raw) => {
  const seen = new Set();
  return String(raw || '')
    .split(',')
    .map((n) => n.trim())
    .filter((n) => {
      const key = n.toLowerCase();
      if (!n || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export const transactionNumbersOf = (row) =>
  parseTransactionNumbers(row?.transaction_number ?? row?.transactionNumber);

// What the upload dialog will send: existing numbers plus the typed one, minus the unticked ones.
// value is null when nothing changes, so the task keeps its current numbers.
export const transactionNumberChoices = (existing, typed, unticked) => {
  const candidates = parseTransactionNumbers([...existing, typed].join(','));
  const known = new Set(existing.map((n) => n.toLowerCase()));
  const hasNew = candidates.some((n) => !known.has(n.toLowerCase()));
  const ticked = candidates.filter((n) => !unticked.includes(n.toLowerCase()));
  const changed = hasNew || ticked.length < candidates.length;
  return {
    candidates,
    ticked,
    hasNew,
    tooMany: ticked.length > MAX_TRANSACTION_NUMBERS,
    value: changed && ticked.length > 0 ? ticked.join(',') : null,
  };
};
